import { Theme } from '@mui/material';

/**
 * return styles used for the component
 * @example <directoryStyles />
 * @returns styles
 */
const ccfCommitmentStyles = (theme: Theme) => {
  return {
    formWrapper: {
      width: '100%',
      height: '100%',
      '>button, >button:hover': {
        border: '0',
        background: 'none',
        color: '#306484',
        boxShadow: 'none',
        padding: '0',
        justifyContent: 'left',
      },
    },
    formWrapperLargeView: {
      height: 'calc(100% - 30px)',
    },
    titleContainer: {
      width: '100%',
    },
    formContainer: {
      width: '100%',
      padding: '0 8px',
      height: 'calc(100% - 52px)',
      overflowY: 'auto',
    },
    iconContainer: {
      display: 'flex',
      alignItems: 'center',
      padding: '11px 0 0 8px',
      fontSize: theme.typography.h4,
      button: {
        padding: '0',
        fontSize: theme.typography.h3,
        svg: {
          fontSize: theme.typography.h5,
        },
      },
      '>p': {
        padding: '0',
      },
    },
    dividerStyles: {
      margin: '10px 0',
      width: '100%',
    },
    textFieldWrapper: {
      display: 'flex',
      flexDirection: 'column',
      width: '49%',
    },
    formLabelBold: {
      color: '#808080',
      fontSize: theme.typography.h5,
      fontWeight: theme.typography.fontWeightBold,
      paddingBottom: '5px',
    },
    formLabel: {
      padding: '0 0 8px 0',
      span: {
        fontSize: theme.typography.h5,
        padding: '0',
        input: {
          padding: '0',
        },
      },
      label: {
        margin: '0',
        '.MuiFormControlLabel-label': {
          padding: '0 15px 0 5px',
        },
      },
    },
    formLabelBoldRequired: {
      color: '#808080',
      fontSize: theme.typography.h5,
      fontWeight: theme.typography.fontWeightBold,
      paddingBottom: '5px',
      '&::after': {
        content: '" *"',
      },
    },
    labelFont: {
      paddingTop: '5px',
      fontSize: theme.typography.h5,
      color: '#80808',
      '&::after': {
        content: '" *"',
      },
    },
    datePicker: {
      '>div': {
        paddingRight: '13px',
        fontSize: theme.typography.h5,
      },
      button: {
        paddingRight: '0px',
        '&:hover': {
          backgroundColor: 'unset',
        },
      },
    },
    wrappperContainer: {
      padding: '20px 0 0 0',
    },
    contactStyles: {
      border: '1px solid #dae2e8',
      borderRadius: '4px',
      fontSize: theme.typography.h5,
      padding: '8px 8px',
      textAlign: 'center',
      width: '20%',
      backgroundColor: theme.palette.background.default,
      height: 'fit-content',
    },
    buttonWrapper: {
      padding: '15px 0 10px 0',
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'center',
      width: '100%',
      gap: '10px',
    },
    timeZoneStyles: {
      fontSize: theme.typography.h5,
    },
    selectOption: {
      maxWidth: '20%',
    },
    textStyles: {
      fontSize: theme.typography.h5,
    },
    textFieldStyles: {
      input: {
        fontSize: theme.typography.h5,
      },
    },
    textAreaStyles: {
      textarea: {
        fontSize: theme.typography.h5,
      },
    },
    contactTextFieldStyles: {
      width: '78%',
      input: {
        fontSize: theme.typography.h5,
      },
    },
    helperTextStyles: {
      margin: 0,
    },
    menuItemStyle: {
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      display: 'block',
    },
    container: {
      display: 'flex',
      gap: '5px',
    },
    commitmentDetailsWrapper: {
      background: theme?.palette?.background?.paper,
      height: '160px',
      width: '260px',
      display: 'flex',
      flexDirection: 'column',
      gap: '9px',
      '& p': {
        margin: '0',
        fontSize: '14px',
      },
      '& + Mui-Tooltip-arrow': {
        color: theme?.palette?.background?.paper,
        background: 'black',
      },
    },
    tooltipArrow: {
      '& span.MuiTooltip-arrow': {
        color: theme?.palette?.background?.paper,
        '&::before': {
          border: '1px solid #dde4e9',
        },
      },
    },
    heading: {
      fontWeight: '700',
      fontSize: '14px',
    },
    commitmentTitle: {
      textDecoration: 'underline',
      fontWeight: '600',
      fontSize: '14px',
    },
    detail: {
      display: 'flex',
      alignItems: 'center',
      gap: '10px',
    },
    icon: {
      color: theme?.palette?.secondary?.main,
      height: '20px',
      width: '20px',
    },
    buttonWrapperTooltip: {
      display: 'flex',
      justifyContent: 'flex-end',
      marginRight: '10px',
      gap: '7px',
    },
    btn: {
      padding: '2px',
      '& p': {
        fontWeight: '600',
        fontSize: '14px',
      },
    },
    textArea: {
      '& div.MuiInputBase-root': {
        padding: '10px',
        marginBottom: '10px',
        fontSize: '14px',
      },
    },
    circle: {
      height: '16px',
      width: '16px',
      background: '#ffb000',
      borderRadius: '50%',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      marginTop: '4px',
      '&::before': {
        content: '""',
        background: theme?.palette?.background?.paper,
        height: '6px',
        width: '6px',
        borderRadius: '50%',
      },
    },
    notesHelperTextStyles: {
      margin: '0',
      marginBottom: '10px',
    },
    fcEventTitleContainer: {
      flexGrow: 0,
      paddingRight: '2px',
    },
    fcEventTitle: {
      textTransform: 'uppercase',
      textAlign: 'center',
      fontWeight: 'bold',
      fontSize: '0.6875rem',
    },
    fcSticky: {
      position: 'static',
    },
    fcEventMainFrame: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100%',
    },
    fcEventMainFrameBorder: {
      height: '100%',
      position: 'absolute',
      margin: '2px',
      left: '1px',
      top: '-2px',
    },
    commitmentNotes: {
      font: `normal normal 600 0.75rem/1.063rem ${theme?.typography?.fontFamily}`,
      color: theme?.palette?.text?.secondary,
      padding: '0.125rem',
      paddingLeft: '0.500rem',
      letterSpacing: '0rem',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'pre',
    },
    commitmentControls: {
      display: 'flex',
      gap: '5px',
      padding: '10px',
    },
    commitmentControlButton: {
      '>p': {
        fontSize: '14px',
      },
    },
    deleteIconButton: {
      padding: '2px',
    },
    disabled: {
      backgroundColor: theme?.palette?.background?.default,
    },
  };
};

export default ccfCommitmentStyles;
